import React from 'react';
import Loading from './Loading';
import { useTranslation } from 'react-i18next';

const Button = ({ type, className, onClick, children, disabled, withLoading }) => {
  const { t } = useTranslation();
  const classNames = withLoading ? 'd-flex align-items-center justify-content-center' : '';
  return (
    <button type={type} className={`btn ${classNames} ${className}`} onClick={onClick} disabled={disabled}>
      {withLoading && <Loading className='text-white mr-4' classSpinner='spinner-border-sm' />}
      {withLoading ? t('text_loading') : children}
    </button>
  );
};

Button.defaultProps = {
  className: 'btn-primary',
  onClick: () => {},
};

export default Button;
